// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"7b1c8d58","124":"34483bfc","265":"e9d28672","369":"c9d31726","422":"fb542b26","491":"7bd81dca","567":"55c0b99f","672":"217756b2","691":"d9759cbb","800":"4eaee5ca","860":"aa2f3ad9","885":"8114868e","971":"95b72729"}[chunkId] + ".chunk.js";
};